<div class="bg-orange-300 flex justify-between px-4 py-5">
  <span class="text-grey-800">Preview</span>
  <button class="lg:hidden" (click)="close.emit()" data-test-id="close-preview">
    <span class="text-blue-400 font-bold">Close</span>
  </button>
</div>
